import React from "react";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { useCatalog } from "@/state/CatalogContext";
import { COMPARE_MAX, useCompare } from "@/lib/compare";

/** Floating bar that appears once something is picked for comparison. */
export function CompareBar({ raised = false }: { raised?: boolean }) {
  const { t } = useI18n();
  const { navigate } = useRouter();
  const { ids, clear } = useCompare();
  const { getProduct } = useCatalog();
  const names = ids.map((id) => getProduct(id)?.name).filter(Boolean);
  if (ids.length === 0) return null;
  return (
    <div className={`compare-bar ${raised ? "compare-bar--raised" : ""}`}>
      <span className="compare-bar__text">
        <b>{t("compare.bar", { count: ids.length, max: COMPARE_MAX })}</b>
        <small>{names.join(" · ")}</small>
      </span>
      <button className="link-button" onClick={clear}>
        {t("compare.clear")}
      </button>
      <button className="btn btn--primary" style={{ width: "auto", minHeight: 38, padding: "8px 14px" }} disabled={ids.length < 2} onClick={() => navigate({ name: "compare" })}>
        {t("compare.open")}
      </button>
    </div>
  );
}
